import styled, {css} from 'styled-components';

export const PopOverlayWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        position: fixed;
        top:0;
        left:0;
        bottom:0;
        right: 0;
        background-color: rgba(0,0,0,0.5);
        align-items: center;
        justify-content: center;
    `,
);

export const PopContentWrap = styled.div(
  props => `
        width:51rem;
        display: flex;
        flex-direction: column;
        background-color: ${props.theme.colors.white.base};
        box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.4);
        border-radius: 1rem;

        @media(max-width:768px){
            width:100%;
            max-width:90%;
            margin:0 auto;
            max-height:400px;
            overflow:auto;
        }
    `,
);

export const PopHeaderWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        padding: ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l15};
        align-items: center;
        justify-content: space-between;

        @media(max-width:768px){
            padding: ${props.theme.spacing.large.l20};
        }
    `,
);

export const PopHeadTex = styled.p(
  props => `
        font-size: ${props.theme.font.large.font26};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
    `,
);

export const PopBodyWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l30};
        flex-direction: column;

        @media(max-width:768px){
            padding: ${props.theme.spacing.large.l20};
        }
    `,
);

export const UserOptionWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: ${props.theme.spacing.large.l20};
    `,
);

export const UserOptionInnerMultiWrap = styled.div(
  props => `
        width:48%;
        display: flex;
        flex-direction: column;
    `,
);

export const UserOptionInnerWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        flex-direction: column;
    `,
);

export const CommonLabel = styled.label(
  props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        padding-bottom: ${props.theme.spacing.small.s8};
    `,
);

export const UserOptionThreeWrap = styled.div(
  props => `
        width:32%;
        display: flex;
        flex-direction: column;
    `,
);

export const CommonInput = styled.input(
  props => `
      width: 100%;
      height: 4.2rem;
      border: 1px solid ${props.theme.colors.grey.light9b};
      background-color: ${props.theme.colors.white.base};
      border-radius: ${props.theme.misc.borderRadius.base};
      font-size: ${props.theme.font.large.font14};
      padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l15};
      color: ${props.theme.colors.grey.base};
      position: relative;
      cursor: pointer;
      ::placeholder {
      lin-height: ${props.theme.font.lineHeight.large};
      font-size: ${props.theme.font.large.font14};
      color: ${props.theme.colors.grey.light9b};
      overflow: visible;
    }
    opacity: ${props.disabled ? '0.4' : '1'};
    pointer-events: ${props.disabled ? 'none' : ''};

    border-color: ${props.hasError ? props.theme.colors.red.base : ''};

    text-transform: ${props.isPAN ? props.theme.font.textTransform.upper : ''};
`,
);

export const CommonSelect = styled.select(
  props => `
    width: 100%;
    height: 4.2rem;
    background-color: ${props.theme.colors.white.base};
    display: flex;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    padding: ${props.theme.spacing.small.s5} ${props.theme.spacing.large.l30} ${
    props.theme.spacing.small.s5
  } ${props.theme.spacing.base};
    border: 1px solid ${props.theme.colors.grey.light9b};
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.base};
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.base};
    background-image: url('https://assets-gos3.goibibo.com/downarrow-1587111682.png');
    background-repeat: no-repeat;
    background-position: 95% 50%;
    background-size: 1.1rem auto;
    cursor: pointer;
    ::-ms-expand {
      display: none;
    }
    opacity: ${props.disabled ? '0.4' : '1'};
    pointer-events: ${props.disabled ? 'none' : ''};
    border-color: ${props.hasError ? props.theme.colors.red.base : ''};
`,
);

export const ButtonOptionWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-top: ${props.theme.spacing.large.l20};
    `,
);

export const CancelBtn = styled.a(
  props => `
    font-size: ${props.theme.font.large.font16};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    cursor: pointer;
    &:hover{
        color: ${props.theme.colors.grey.base};
    }
`,
);

export const SaveBtn = styled.button(
  props => `
        outline: none;
        border: none;
        border-radius: 4px;
        box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.2);
        background-image: linear-gradient(97deg, #53b2fe 2%, #065af3 129%);
        padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l50};
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.white.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        margin-left: ${props.theme.spacing.large.l30};
        cursor: pointer;
    `,
);

export const UserInfoForm = styled.form(
  props => `
          width:100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-direction: column;
      `,
);
